import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { Employment, Position, noDateOnCompensation, noValueOnCompensation  } from '../../../employment/employment-model';
import { DividerSection } from '../../../../../../../stories/divider-section';
import { LabelAndValue } from '../../../../../../global/components/data-display/label-value';
import { getFormattedDate } from '../../../../../../global/helpers/date-helpers';
import { useMemberEmployment } from '../hooks/useMemberEmployment';
import { useMemberCompensation } from '../hooks/useMemberCompensation';
import { PageHeader } from '../../../../../../global/components/layout/page-header';
import { LabelSettingProps } from '../../../../../../global/models/epi-model';
import { YesNoIndicators } from '../../../../../../global/models/api-model';


export function MemberEmploymentCompensationReview() {

    const memberCompensationLoaded = useMemberCompensation();
    const memberEmploymentLoaded = useMemberEmployment();
	
	const labelSettings = useSelector<TcsmStates, LabelSettingProps>(state => state?.epiProps?.labelSettingState?.epiContent);
	const newHirePropsLoaded = useSelector<TcsmStates, boolean>(state => state?.epiProps?.newHireSettingsState?.contentLoaded);
    const newHireProps = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);
    const memberEmployment = useSelector<TcsmStates, Employment>(state => state?.newHireEnrollmentState?.memberEmployment);
	const memberCompensationState = useSelector<TcsmStates, any>(state => state?.newHireEnrollmentState?.memberCompensation);
	const memberCompensation = memberCompensationState?.compensations?.[0] ?? null;

	const positionView = (position: Position) => {
		return (
			<>
				<p>{position?.position_title}</p>
				<p className='grey-caption'>{getFormattedDate(position?.start_date)} - {getFormattedDate(position?.end_date) || newHireProps?.presentLabel}</p>
			</>
		);
	};

	if (!memberEmploymentLoaded || !memberCompensationLoaded || !newHirePropsLoaded) {
		return <LoadingCircle />;
	}

	return (
		<>
			{
				memberEmployment &&
				<>
					<PageHeader headerText={newHireProps?.employmentCompensationHeader} description={newHireProps?.employmentCompensationDescription} />
					<DividerSection sectionText={`${getFormattedDate(memberEmployment?.current_position_title_start_date)} - ${newHireProps?.presentLabel}`}>
						<h4>{newHireProps?.employmentTitle}</h4>
						<LabelAndValue label={newHireProps?.institutionLabel} value={memberEmployment?.employer_name} />
						<LabelAndValue
							label={newHireProps?.positionLabel}
							value={<>
								{
									memberEmployment?.position_titles?.map((positionItem: Position) => {
										return positionView(positionItem);
									})
								}
							</>}
						/>
						<LabelAndValue label={newHireProps?.addressLabel}
							value={
								<>
									<div>{`${memberEmployment?.employer_street_address},`}</div>
									<div>{`${memberEmployment?.employer_location}, ${memberEmployment?.employer_country}`}</div>
								</>
							} />
						<h4>{newHireProps?.compensationTitle}</h4>
						<LabelAndValue label={newHireProps?.baseSalaryLabel} value={memberCompensation?.cash_salary ?? noValueOnCompensation} tooltipMessage={newHireProps?.baseSalaryTooltip} />
						<LabelAndValue label={newHireProps?.cashHousingAllowanceLabel} value={memberCompensation?.housing_cash_allowance ?? noValueOnCompensation} tooltipMessage={newHireProps?.cashHousingAllowanceTooltip} />
						<LabelAndValue label={newHireProps?.employerProvidedHousingLabel} value={memberCompensation?.housing_provided === YesNoIndicators.Yes ? labelSettings?.yesText : labelSettings?.noText } tooltipMessage={newHireProps?.employerProvidedHousingTooltip} />
						<LabelAndValue label={newHireProps?.erPlanContributionsLabel} value={memberCompensation?.er_plan_contributions ?? noValueOnCompensation} tooltipMessage={newHireProps?.erPlanContributionsTooltip} />
						<LabelAndValue label={newHireProps?.dbHousingValueLabel} value={memberCompensation?.calculated_housing ?? noValueOnCompensation} tooltipMessage={newHireProps?.dbHousingValueHelper} />
						<LabelAndValue label={newHireProps?.dcHousingValueLabel} value={memberCompensation?.calculated_housing_dc_rsvp ?? noValueOnCompensation} tooltipMessage={newHireProps?.dcHousingValueHelper} />
						<LabelAndValue label={newHireProps?.dbCompTotalLabel} value={memberCompensation?.tac ?? noValueOnCompensation} tooltipMessage={newHireProps?.dbCompTotalHelper} />
						<LabelAndValue label={newHireProps?.dcCompTotalLabel} value={memberCompensation?.tac_dc_rsvp ?? noValueOnCompensation} tooltipMessage={newHireProps?.dcCompTotalHelper} />
						<LabelAndValue label={newHireProps?.effectiveDateLabel} value={getFormattedDate(memberCompensation?.effective_date) ?? noDateOnCompensation}/>

					</DividerSection>
				</>
			}
		</>
	);
}